import React, { useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

export const Expand = ({ id, expanded, children }) => {
  const measure = useRef()

  return (
    <div className="container-xxl overflow-hidden" style={{
      transition: 'height 0.3s',
      height: expanded == id
      ? measure.current
      ? measure.current.offsetHeight + 'px'
      : 'auto'
      : 0,
    }}>
      <div ref={measure}>
        {children}
      </div>
    </div>
  )
}

export const Toggle = ({ id, toggleExpanded, label }) =>
  <button
    type="button"
    className="btn btn-link p-0 ms-1"
    onClick={() => toggleExpanded(id)}
    title={label}
  >
    <FontAwesomeIcon icon={faInfoCircle} />
  </button>
